import { useContext } from 'react';
import { SurveyThemingContext } from '@containers/Branding/Context';

export const useSurveyThemingLoading = () => {
  const ctx = useContext(SurveyThemingContext);

  return ctx.theming.loading;
};